/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import './style.sass';
import { withFormik, Field } from "formik";
import httpService from "../../../../api/httpLocationService";
import classNames from "classnames";


const RadioButton = ({
  field: { name, value, onChange, onBlur },
  id,
  label,
  className,
  first,
  ...props
  }) => {
  return (
    <div className='quick-search-radio-buttons'>
      <label htmlFor={id}>
        <input
          name={name}
          id={id}
          type="radio"
          value={id}
          checked={id === value}
          onChange={onChange}
          onBlur={onBlur}
          className={classNames("radio-button")}
          {...props}
        />
        {label}
      </label>
    </div>
  );
};

const RadioButtonGroup = ({
    value,
    error,
    touched,
    id,
    label,
    className,
    children
  }) => {

  return (
    <div>
      <strong>{label}</strong>
      {children}
      <div className="validation-message">
        {touched && error ? error : null}
      </div>
    </div>
  );
};

const QuickSearchForm = (props) => {
  const {
    aboutUsPath,
    formAuthToken,
    handleSubmit,
    handleChange,
    handleBlur,
    touched,
    errors,
    values,
  } = props;

  return (
    <div className="content">
      <div className="quickSerchForm">
        <h3 className="sidebar-header colored--o">{I18n.t('about_us.form.legend')}</h3>
        <p>
          <strong>
            {I18n.t('about_us.form.purpose')}
          </strong>
        </p>

        <form
          name="signupProviderForm"
          className="order-form quick-search"
          onSubmit={handleSubmit}
        >
          <div className="row">
            <div className="col-md-6">

              <input
                name="authenticity_token"
                value={formAuthToken}
                type="hidden"
              />

              <div className="quicksearch-group">
                <label htmlFor="company">
                  {I18n.t('virtual_office.form.company')}
                  <input
                    name="company"
                    type="text"
                    value={values.company}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={
                      touched.company ? (errors.company ? 'error' : 'is-valid') : null
                    }
                  />
                  <div className="validation-message">
                    {touched.company && errors.company ? errors.company : null}
                  </div>
                </label>
              </div>

              <div className="quicksearch-group">
                <label htmlFor="phone">
                  {I18n.t('virtual_office.form.phone')}
                  <input
                    name="phone"
                    value={values.phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={
                      touched.phone ? (errors.phone ? 'error' : 'is-valid') : null
                    }
                  />

                  <div className="validation-message">
                    {touched.phone && errors.phone ? errors.phone : null}
                  </div>
                </label>
              </div>

              <RadioButtonGroup
                id="search"
                label={I18n.t('about_us.form.radiobuttons')}
                value={values.search}
                error={errors.search}
                touched={touched.search}
              >
                <Field
                  component={RadioButton}
                  name="search"
                  id="office"
                  first="roman"
                  label={I18n.t('about_us.form.radiobutton.office')}
                />
                <Field
                  component={RadioButton}
                  name="search"
                  id="virtual_office"
                  label={I18n.t('about_us.form.radiobutton.virtual_office')}
                />
                <Field
                  component={RadioButton}
                  name="search"
                  id="meeting_room"
                  label={I18n.t('about_us.form.radiobutton.meeting_room')}
                />
              </RadioButtonGroup>

            </div>

            <div className="col-md-6">
              <div className="quicksearch-group">
                <label htmlFor="name">
                  {I18n.t('virtual_office.form.name')}
                  <input
                    name="name"
                    type="text"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={
                      touched.name ? (errors.name ? 'error' : 'is-valid') : null
                    }
                  />
                  <div className="validation-message">
                    {touched.name && errors.name ? errors.name : null}
                  </div>
                </label>
              </div>

              <div className="quicksearch-group">

                <label htmlFor="email">
                  {I18n.t('virtual_office.form.email')}
                  <input
                    name="email"
                    type="email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={
                      touched.email ? (errors.email ? 'error' : 'is-valid') : null
                    }
                  />

                  <div className="validation-message">
                    {touched.email && errors.email ? errors.email : null}
                  </div>
                </label>
              </div>

              <div className="quicksearch-group">
                <label htmlFor="comment">
                  {I18n.t('about_us.form.comment')}
                  <textarea
                    name="comment"
                    value={values.comment}
                    onChange={handleChange}
                  />
                </label>
              </div>

              <button
                className="form-submit"
                type="submit"
                ref={btn => { this.quickSearchButton = btn; }}
              >
                {I18n.t('provider_signup.form.submit')}
              </button>
            </div>

          </div>
        </form>
      </div>
    </div>
  );
};

QuickSearchForm.propTypes = {
  aboutUsPath: PropTypes.string,
  formAuthToken: PropTypes.string,
};

QuickSearchForm.defaultProps = {
  aboutUsPath: '',
  formAuthToken: '',
};

const QuickSearchFormValidation = withFormik({
  mapPropsToValues: (bag) => ({
    company: '',
    phone: '',
    search: '',
    name: '',
    authenticity_token: bag.formAuthToken,
    email: '',
    comment: '',
  }),


  validate: values => {
    let errors = {};
    if (!values.name) {
      errors.name = I18n.t('sidebar.order.form.required-field');
    }
    if (!values.company) {
      errors.company = I18n.t('sidebar.order.form.required-field');
    }

    if (!values.email) {
      errors.email = I18n.t('sidebar.order.form.required-field');
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
        values.email
      )
    ) {
      errors.email = I18n.t('sidebar.order.form.invalid-email');
    }

    if (!values.phone) {
      errors.phone = I18n.t('sidebar.order.form.required-field');
    } else if (
      !/^\+?([\d]*\d){10,}$/i.test(
        values.phone.replace(/[-\s()]/g, '')
      )
    ) {
      errors.phone = I18n.t('sidebar.order.form.invalid-phone');
    }

    if (!values.search) {
      errors.search = I18n.t('sidebar.order.form.required-field');
    }

    return errors;
  },

  handleSubmit: (values, bag) => {
    this.quickSearchButton.setAttribute("disabled", "disabled");

    httpService.quickSearchForm(values, bag.props.aboutUsPath, bag.props.formAuthToken)
      .then(() => {
        window.location.replace('/orders/success?type=sign_up');
      });
  },

  displayName: 'QuickSearchForm',
})(QuickSearchForm);

export default QuickSearchFormValidation;

// export default QuickSearchForm;
